import * as React from 'react';
import PropTypes from 'prop-types';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';

import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';

import { Button, CircularProgress, Dialog, } from '@mui/material';

import { Link } from 'react-router-dom';
import QuickEdit from './QuickEdit';

import Notes from '../../project-portal/pages/Leads/FullDetailsPage/AddNotes';
const dialogStyle = {
    '& .MuiDialog-paper': {
        width: '700px', // Set fixed width here
        maxWidth: '700px', // Ensure maxWidth is the same to keep it fixed
    }
};

function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            // Always render the panel but hide it with display: none when not active
            style={{ display: value === index ? 'block' : 'none' }}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            <Box pt={2}>
                {children}
            </Box>
        </div>
    );
}

TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.number.isRequired,
    value: PropTypes.number.isRequired,
};

function a11yProps(index) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    };
}

export default function BasicTabs({ id, viewID, open, setOpen, refreshLeadsTable }) {
    // Support both id and viewID props for compatibility
    const leadId = id || viewID;
    
    // Debugging: Log the props to see what's being passed
    React.useEffect(() => {
        console.log("BasicTabs component - id:", id, "viewID:", viewID, "leadId:", leadId, "open:", open);
    }, [id, viewID, leadId, open]);
    
    const [value, setNewValue] = React.useState(0);
    const [data, setData] = React.useState()
    const [loading, setLoading] = React.useState(false)
    const [refreshNotes, setRefreshNotes] = React.useState(0) // Add refresh state

    const handleClose = () => setOpen(false);

    const handleChange = (event, newValue) => {
        setNewValue(newValue);
    }

    // Reset tab to default (0) when modal opens
    React.useEffect(() => {
        if (open) {
            setNewValue(0);
            // Reset notes refresh when modal opens
            setRefreshNotes(0);
            // Trigger notes fetch when modal opens
            if (refreshNotes === 0) {
                setRefreshNotes(1);
            }
        }
    }, [open]);

    // Function to trigger notes refresh
    const triggerNotesRefresh = () => {
        setRefreshNotes(prev => prev + 1);
    };

    return (
        <>
            <Dialog
                open={open}
                onClose={handleClose}
                aria-labelledby="dialog-title"
                sx={dialogStyle}
                aria-describedby="dialog-description"
            >
                {loading ? (
                    <Box sx={{
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        width: '100%',
                        height: '30vh'
                    }}>
                        <CircularProgress />
                    </Box>
                ) : (
                    <>
                        <Box sx={{ width: '100%', mt: 1, height: '70vh' }}>
                            <Box sx={{ borderBottom: 1, borderColor: 'divider', marginLeft: 3 }}>
                                <Tabs value={value} onChange={handleChange} aria-label="basic tabs example">
                                    <Tab label="Quick Edit" {...a11yProps(0)} />
                                    <Tab label="Notes" {...a11yProps(1)} />
                                </Tabs>
                            </Box>

                            {/* Keep both components mounted but hidden when not active */}
                            <TabPanel value={value} index={0}>
                                <QuickEdit 
                                    id={leadId} 
                                    open={value === 0 && open} 
                                    setOpen={setOpen} 
                                    notesTabActive={value === 1}
                                    refreshNotes={refreshNotes}
                                    triggerNotesRefresh={triggerNotesRefresh}
                                    refreshLeadsTable={refreshLeadsTable}
                                />
                            </TabPanel>
                            <TabPanel value={value} index={1}>
                                <Box padding={2} pt={0}>
                                    <Notes viewID={leadId} refreshParent={triggerNotesRefresh} isActive={value === 1} />
                                </Box>
                            </TabPanel>
                        </Box>
                    </>
                )}
            </Dialog>
        </>
    );
}